<template>
	<v-dialog max-width="550px" v-model="isOpen" persistent>
		<v-form :disabled="!isEditable">
			<v-card width="100%" class="pa-4">
				<v-row>
					<v-col md="12">
						<h1 class="font-weight-light primary--text">Gestión</h1>
					</v-col>
				</v-row>
				<v-row>
					<v-col md="12" cols="12">
						<v-card elevation="0" class="px-md-4 pb-4">
							<!-- <v-row>
								<v-col md="12" class="mb-md-1 mt-md-1">
									<h4 class="font-weight-light primary--text">
										Comercial
									</h4>
								</v-col>
							</v-row>
							<v-divider></v-divider> -->
							<v-row>
								<v-col md="12" class="mb-md-n4">
									<v-combobox
										clearable
										chips
										hide-selected
										:items="comerciales"
										item-text="nombreCompleto"
										item-value="item"
										v-model="form.comercial"
										label="Comercial"
									>
										<template #item="{ item }">
											<v-row>
												<v-col cols="8">
													{{ item.nombreCompleto }}
												</v-col>
												<v-col
													v-if="item.estado"
													cols="4"
												>
													<v-chip
														label
														:color="
															estadoComercial[
																item.estado
															]
														"
														medium
														class="
															d-flex
															justify-center
															overline
														"
													>
														{{ item.estado }}
													</v-chip>
												</v-col>
											</v-row>
										</template>
										<template #selection="{ item }">
											<v-chip
												:color="
													!isEditable
														? 'purple lighten-3'
														: 'purple'
												"
												class="white--text"
											>
												<v-icon left size="20">
													mdi-account-circle-outline
												</v-icon>
												{{ item.nombreCompleto }}
											</v-chip>
										</template>
									</v-combobox>
								</v-col>
							</v-row>
						</v-card>
					</v-col>
				</v-row>
				<v-row>
					<v-col md="12" cols="12">
						<v-card elevation="0" class="px-md-4 pb-4">
							<!-- <v-row>
								<v-col md="12" class="mb-md-1 mt-md-1">
									<h4 class="font-weight-light primary--text">
										Tipo de Gestión Realizada
									</h4>
								</v-col>
							</v-row>
							<v-divider></v-divider> -->
							<v-row>
								<v-col md="12" class="mb-md-n4">
									<v-combobox
										clearable
										chips
										hide-selected
										:items="administrations"
										item-text="name"
										return-object
										v-model="form.gestion"
										label="Tipo de Gestión"
									>
										<template #selection="{ item }">
											<v-chip
												:color="
													!isEditable
														? 'red lighten-3'
														: 'red'
												"
												class="white--text"
											>
												{{ item.name }}
												<v-icon class="ml-1">
													mdi-ticket
												</v-icon>
											</v-chip>
										</template>
									</v-combobox>
								</v-col>
							</v-row>
						</v-card>
					</v-col>
				</v-row>
				<!-- <v-row v-if="form.gestion && form.gestion.name.toLowerCase().includes('renuevo')">
                    <v-col md="12" cols="12">
                        <v-card elevation="0" class="px-md-4 pb-4">
                            <v-row>
                                <v-col md="12" class="mb-md-1 mt-md-1">
                                    <h4 class="font-weight-light primary--text">
                                        Terminal Asociado
                                    </h4>
                                </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-row>
                                <v-col md="12" class="mb-md-n4">
                                    <v-combobox
                                        clearable
                                        chips
                                        hide-selected
                                        :items="terminals"
                                        item-text="name"
                                        v-model="notas"
                                        label="Dispositivo"
                                    >
                                        <template #selection="{ item }">
                                            <v-chip
                                                :color="
                                                    !isEditable
                                                        ? 'pink lighten-3'
                                                        : 'pink'
                                                "
                                                class="white--text"
                                            >
                                                {{ item.name }}
                                                <v-icon class="ml-1">
                                                    mdi-phone
                                                </v-icon>
                                            </v-chip>
                                        </template>
                                    </v-combobox>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row> -->
				<v-row>
					<v-col cols="12">
						<v-card elevation="0" class="px-md-4 pb-4">
							<!-- <v-row>
								<v-col md="12" class="mb-md-1 mt-md-1">
									<h4 class="font-weight-light primary--text">
										Números Asociados
									</h4>
								</v-col>
							</v-row>
							<v-divider></v-divider> -->
							<v-row>
								<v-col md="12" class="mb-md-n4">
									<v-combobox
										clearable
										chips
										hide-selected
										:items="ttForm.telefonosContacto"
										item-text="name"
										:error-messages="
											phoneNumberErrorMessages
										"
										v-model="notas"
										return-object
										@change="checkPhonenumber()"
										label="Número Asociado"
									>
										<template #selection="{ item }">
											<v-chip
												:color="
													!isEditable
														? 'green lighten-3'
														: 'green accent-2'
												"
												class="white--text"
											>
												{{ item }}
												<v-icon class="ml-1">
													mdi-phone
												</v-icon>
											</v-chip>
										</template>
									</v-combobox>
								</v-col>
							</v-row>
						</v-card>
					</v-col>
				</v-row>
				<v-row v-if="form.gestion">
					<v-col md="12" cols="12" class="pr-md-1">
						<v-card elevation="0" class="px-md-4 pb-4">
							<v-row>
								<v-col md="12" class="mb-md-1 mt-md-1">
									<h4 class="font-weight-light primary--text">
										Operador
									</h4>
								</v-col>
							</v-row>
							<v-divider></v-divider>
							<v-row>
								<v-col md="12" class="mb-md-n4">
									<v-text-field
										clearable
										v-model="form.gestion.operator"
										disabled
										label="Operador"
									>
									</v-text-field>
								</v-col>
							</v-row>
						</v-card>
					</v-col>
				</v-row>
				<v-card-actions class="justify-end mb-md-n4">
					<v-btn v-if="isEditable" depressed color="primary" @click="save">
						Guardar
					</v-btn>
					<v-btn text color="red" @click="closeForm"> Cerrar </v-btn>
				</v-card-actions>
			</v-card>
		</v-form>
	</v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { clone } from '@/util/libUtil.js';
import defaultAtencionGestionForm from '@/util/atenciones/defaultAtencionGestionForm';

export default {
	name: 'AdministrationForm',
	data: () => ({
		estadoComercial: {
			ALTA: 'success',
			BAJA: 'warning',
			INACTIVO: 'error',
			VACACIONES: 'blue',
		},
		phoneNumberErrorMessages: null,
	}),
	computed: {
		isOpen: {
			get() {
				return this.$store.state.teletrabajo.AdministrationForm[
					'isOpen'
				];
			},
			set(val) {
				this.clearFields();
				this.$store.state.teletrabajo.AdministrationForm['isOpen'] =
					val;
			},
		},
		notas: {
			get() {
				return this.$store.state.teletrabajo.AdministrationForm.form
					.notas;
			},
			set(val) {
				let regexTelefono = /^(6|7|8|9)([0-9]){8}$/;

				if (val && regexTelefono.test(val))
					this.$store.state.teletrabajo.AdministrationForm.form.notas =
						val;
				else
					this.$store.state.teletrabajo.AdministrationForm.form.notas =
						null;
			},
		},
		...mapState('teletrabajo', {
			ttForm: (state) => state.TtForm,
			administrations: (state) => state.administrations,
			comerciales: (state) => state.Comerciales,
			form: (state) => state.AdministrationForm.form,
			isEditable: (state) => state.AdministrationForm['isEditable'],
		}),
		...mapState('configuradorOferta', {
			terminals: (state) => state.terminals,
		}),
	},
	methods: {
		clone(obj) {
			return JSON.parse(JSON.stringify(obj));
		},
		clearFields() {
			this.$store.state.teletrabajo.AdministrationForm.form = clone(
				defaultAtencionGestionForm
			);
			this.$store.state.teletrabajo.AdministrationForm.form.notas = null;
		},
		closeForm() {
			this.$store.state.teletrabajo.AdministrationForm.isOpen = false;
		},
		save() {
			if (this.phoneNumberErrorMessages == null) {
				this.closeForm();
				this.addAdministration();
				if (
					!this.$store.state.teletrabajo.TtForm.telefonosContacto.some(
						(item) => item == this.notas
					)
				) {
					this.$store.state.teletrabajo.TtForm.telefonosContacto.push(
						this.notas
					);
					this.saveTtForm();
				}
			}
		},
		checkPhonenumber(val) {
			let regexTelefono = /^(6|7|8|9)([0-9]){8}$/;

			if (val && !regexTelefono.test(val))
				this.phoneNumberErrorMessages = 'Número de Teléfono no Válido';
			else this.phoneNumberErrorMessages = null;
		},
		...mapActions('teletrabajo', {
			addAdministration: 'addAdministration',
			saveTtForm: 'saveTtForm',
		}),
		...mapActions('configuradorOferta', {
			getTerminals: 'getTerminals',
		}),
	},
	created() {
		// console.log(this.opciones);
		if (this.$store.state.teletrabajo.administrations.length == 0)
			this.$store.dispatch('teletrabajo/getAdministrations');
		if (this.terminals.length == 0)
			var terminalsISP = {
				segment: 'PARTICULAR',
				isp: 'YOIGO',
			};

		this.$store.commit('configuradorOferta/isp', terminalsISP);
		// this.getTerminals()
	},
	watch: {
		comerciales: {
			immediate: true,
			handler: function () {
				this.form.comercial = this.comerciales.find(
					({ id }) => id == this.$store.state.login.id
				);
			},
		},
	},
};
</script>
